import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Trash2 } from 'react-feather';

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const StampTable = ({ useFetchInit, readOnlyMode }) => {

    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllDocumentsStamps } = FetchData
    const { dataDocumentsStamps, loadingFetchAllDocumentsStamps } = fetchAllDocumentsStamps
    
    const {
        handleClickDeleteDocumentsStamps
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "stamp", headerName: "TIMBRE", minWidth: 250, filter: true },
        { field: "quantity", headerName: "CANTIDAD", minWidth: 150, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { iddocumentstamps, idstamp, quantity, estado } = params.data
                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickDeleteDocumentsStamps(iddocumentstamps, idstamp, quantity)}
                            disabled={readOnlyMode}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllDocumentsStamps)&&(<LinearLoading />)}
            <CustomTableData
                rowConfig={dataDocumentsStamps}
                columnConfig={columnConfig}
            />
        </div>
    )
}
